module.exports = __webpack_public_path__ + "static/media/Major Project ETRX 2021-22.ac173850.xlsx";